export const arrivalStatusFunc = (status: string) => {
  switch (status) {
    case 'not_arrived':
      return 'Не присутствовал';
    case 'arrived':
      return 'Присутствовал';
    default:
      return 'Статус отсутствует, для уточнения необходимо обратиться к администратору';
  }
};
